/** @format */

import {styled} from '@mui/material/styles';
import {Box, Button, Typography} from '@mui/material';

export const Root = styled(Box)(({theme}) => ({
  borderRadius: '16px',
  background: theme.palette.figma_surface?.main,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  width: '274px',
  height: '517px',
  flexShrink: 0,
  position: 'relative',
}));

export const DescriptionBox = styled(Box)(({theme}) => ({
  height: '160px',
  padding: theme.spacing(6, 4, 0, 4),
}));

export const DescriptionText = styled(Typography)(({theme}) => ({
  color: theme.palette.figma_gray_light_4?.main,
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
}));

export const PlanBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1px',
  borderRadius: '8px',
  overflow: 'hidden',
  margin: theme.spacing(0, 2),
}));

export const CurrencyWrap = styled(Box)(({theme}) => ({
  '.MuiSvgIcon-root': {
    color: theme.palette.figma_surface?.light,
  },
}));

export const PriceBox = styled(Box)(({theme}) => ({
  height: '144px',
  padding: theme.spacing(12, 0, 0, 4),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const OldPriceText = styled(Typography)(({theme}) => ({
  color: theme.palette.figma_surface_muted?.main,
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
  textDecorationLine: 'line-through',
}));

export const OldPriceDummy = styled(Box)(() => ({
  height: '20px',
}));

export const ActualPriceText = styled(Typography)(({theme}) => ({
  color: theme.palette.figma_gray_light_4?.main,
  textEdge: 'cap',
  fontSize: '40px',
  fontWeight: 400,
}));

export const PriceNotesBox = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(3),
}));

export const ActualPriceNoteText = styled(Typography)(({theme}) => ({
  color: theme.palette.figma_gray_light_4?.main,
  fontSize: '20px',
  fontWeight: 400,
  lineHeight: '14px',
}));

export const AskPriceBox = styled(Box)(({theme}) => ({
  paddingTop: theme.spacing(22.5),
  display: 'flex',
  justifyContent: 'center',
}));

export const HelpContentBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));

export const HelpContentText = styled(Typography)(({theme}) => ({
  color: theme.palette.figma_gray_dark_5?.main,
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
}));

interface SelectButtonProps {
  active: boolean;
  cardHover: boolean;
}

export const SelectButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'active' && prop !== 'cardHover',
})<SelectButtonProps>(({theme, active, cardHover}) => ({
  color: theme.palette.figma_gray_light_4?.main,
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
  width: '100%',
  height: '48px',
  background: active
    ? theme.palette.figma_primary?.light
    : cardHover
      ? theme.palette.figma_primary?.dark
      : theme.palette.figma_gray_dark_4?.main,
  position: 'absolute',
  bottom: 0,
  left: 0,
  borderRadius: 0,
  gap: theme.spacing(2),
  boxShadow: cardHover || active ? `0 0 64px 0 ${theme.palette.figma_primary?.main}` : 'none',

  '&.Mui-disabled': {
    background: '#202022',
    color: '#6e6f70',
  },

  '&:hover': {
    background: theme.palette.figma_primary?.main,
  },
}));
